export default "__VITE_ASSET__NOLwlZjg__"